import React, { useContext, useState, useEffect } from "react";
import { Helmet } from "react-helmet"
import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-scroll";

import { device } from "../../utils";

import GlobalContext from "../../context/GlobalContext";
import { Box, Section, Title, ButtonIcon, Button, Text } from "../../components/Core";
import Availability from "../../components/Availability";

import { PopupModal, CalendlyEventListener } from "react-calendly";

import { useNotification, useWindowSize } from "../../hooks";

const ImgRight = styled.img`
  max-width: 100%;
`;

const Hero = (props) => {

  const gContext = useContext(GlobalContext);
  const [re, setRe] = useState(null);
  const [open, setOpen] = useState(false);

  const windowSize = useWindowSize();
  const isMobile = windowSize.width < 400;

  const notifFunc = useNotification(props.username, gContext.getSettings());
  useEffect(() => {
    setRe(document.getElementById("cont"))
  }, [])

  const styles = {
    header: {
      backgroundImage: `url(${props.imgL})`,
      backgroundSize: 'cover'
    },

    content: {
      minHeight: '400px',
      width: '100%',
      backgroundColor: 'rgba(255, 255, 255, 0.7)',
    }
  }

  return (
    <>
      {/* <!-- Hero Area --> */}
      <Helmet>
         <meta charSet="utf-8" />
         <title>BigDog.zone - {props.fullname}</title>
         <link rel="canonical" href={"https://bigdog.zone/" + props.username} />
         <meta name="description" content={props.profile} />
      </Helmet>

      <Section hero className="position-relative">
        <Container id='cont'>
          <Row className="align-items-center">
            <Col lg="7" className="mb-5 mb-lg-0">
              <Box>
                <Title variant="hero">
                  {props.fullname}
                </Title>
                <Text
                  variant="tag"
                  className="text-uppercase"
                  color="heading"
                >
                    {props.homegym}
                </Text>
                <Box mt="12px">
              <Row className="align-items-center">
                <Col xs={12} md={6}>
                  <div className="text-center">
                    <div className="App">
                      <Button
                        onClick={(e) => {
                          e.preventDefault();
                          //gContext.toggleContact();
                          setOpen(true);
                        }} arrowRight
                      >
                          Schedule a
                          <br/>
                          private class
                      </Button>

                    <CalendlyEventListener onEventScheduled={notifFunc}>
                      <PopupModal
                        url={props.calendly}
                        onModalClose={() => setOpen(false)}
                        open={open}
                        rootElement={re}
                      />
                    </CalendlyEventListener>

                    </div>
                  </div>
                </Col>
                <Col xs={12} md={6}>
                  <div className="text-center my-3">
                    <b style={{textTransform: "uppercase"}}> {props.pricing} </b>
                    <br/>
                      (In a squeeze? Message us. We'll figure something out)
                  </div>
                </Col>
              </Row>
                </Box>
                  <div style={isMobile ? styles.header : {}}
                  >
                    <div style={isMobile ? styles.content : {}}>
                      <br/>
                      {props.profile}
                    </div>
                </div>
              </Box>
            </Col>
            { isMobile ? "" :
            <Col lg="5" md="8" sm="9">
              <div className="text-center text-lg-right position-relative">
                <div className="img-main">
                  <ImgRight src={props.imgL} alt={props.fullname} />
                </div>
              </div>
            </Col>
            }
          </Row>
        </Container>
      </Section>
    </>
  );
};

export default Hero;
